import { connect } from 'react-redux'
import TripsHistoryDetailsModal from '../../components/trips/TripsHistoryDetailsModal'
import { getTripsHistory } from '../../state/selectors/index'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const items = getTripsHistory(state)
  return {
    //TODO: use selectors
    items,
    isFetching: state.tripsHistory.isFetching
  }
}

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  return {
    onComponentMount: () => {
      // dispatch(getTripHistoryAction(ownProps.match.params.tripId))
      return
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripsHistoryDetailsModal)



// WEBPACK FOOTER //
// ./src/containers/trips/TripsHistoryDetailsModal.ts